import styled from "styled-components";
import { ONBOARDING_CONTAINER_SIZES } from "./OnboardingStylesConstants";
import { SHADOWS } from "src/apps/config/shadows";
import { RADIUS_SIZES } from "src/apps/config/radius-sizes";
import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${ONBOARDING_CONTAINER_SIZES.defaultWidth};
  min-height: ${ONBOARDING_CONTAINER_SIZES.defaultHeight};
  padding: 2rem;
  gap: 24px;
  box-shadow: ${SHADOWS.lg};
  border-radius: ${RADIUS_SIZES.base};
  justify-content: center;

  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    width: 100%;
    max-width: ${ONBOARDING_CONTAINER_SIZES.defaultWidth};
    box-shadow: none;
    min-height: unset;
    border-radius: 0;
    padding: 0;
  }
`;
